import { Box, Button } from '@mui/material';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_jobSearchResults as JobSearchResult } from '@/__generated__/seoSegmentationListingPage';
import { type JobSearchResultWithURL } from '@/types/SearchDirectory';
import { useResponsive } from '@/components/hooks/useResponsive';
import { JobOverview } from './JobOverview';
import { JobTagList } from './JobTagList';
import { JobDescription } from './JobDescription';

export interface JobCardProps {
  searchResult: JobSearchResult;
}

export const JobCard = ({ searchResult }: JobCardProps) => {
  const { isSmallViewport } = useResponsive();
  // Skip profiles without a URL
  if (searchResult.jobDetailURL === null) return null;

  const validSearchResult: JobSearchResultWithURL = {
    ...searchResult,
    jobDetailURL: searchResult.jobDetailURL,
  };

  return (
    <Box
      width="100%"
      px={3}
      py={4}
      borderRadius={isSmallViewport ? 0 : 6}
      sx={{ mt: { xs: 0.5, sm: 4 }, '&:first-of-type': { mt: 4 } }}
      bgcolor="background.primary">
      <JobOverview searchResult={validSearchResult} />
      {isSmallViewport && <JobTagList sx={{ mt: 2 }} job={validSearchResult.seoSegmentationJob} />}
      <Box
        mt={{ xs: 2, sm: 3 }}
        display="flex"
        flexWrap={isSmallViewport ? 'wrap' : 'nowrap'}
        justifyContent="space-between">
        <JobDescription
          jobDescription={validSearchResult.seoSegmentationJob.description}
          sx={{ width: { xs: '100%', md: 'auto' } }}
        />
        <Button
          href={validSearchResult.jobDetailURL}
          target={isSmallViewport ? undefined : '_blank'}
          rel="noopener"
          size="medium"
          fullWidth={isSmallViewport}
          sx={{
            minWidth: '160px',
            ml: { xs: 0, md: 4 },
            mt: { xs: 4, md: 0 },
            alignSelf: 'flex-end',
          }}
          color="primary"
          variant="contained">
          See&nbsp;details
        </Button>
      </Box>
    </Box>
  );
};
